import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LoadingSpinner } from './LoadingSpinner';

interface PageTransitionProps {
  children: React.ReactNode;
  duration?: number;
}

export const PageTransition: React.FC<PageTransitionProps> = ({ 
  children, 
  duration = 300 
}) => {
  const location = useLocation();
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    // Start transition
    setIsTransitioning(true);
    
    // End transition after duration
    const timer = setTimeout(() => {
      setIsTransitioning(false);
    }, duration);

    return () => {
      clearTimeout(timer);
    };
  }, [location.pathname, duration]);

  return (
    <>
      {/* Page content with fade transition */}
      <div 
        className={`
          transition-opacity ease-in-out
          motion-reduce:transition-none motion-reduce:duration-0
          ${isTransitioning ? 'opacity-0' : 'opacity-100'}
        `}
        style={{
          transitionDuration: `${duration}ms`,
        }}
      >
        {children}
      </div>
    </>
  );
};